import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { KeyNumberService } from '../../core/services/key-number.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-studio-key',
    imports: [MaxLengthValidatorDirective, FormsModule, CommonModule, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn" >
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa fa-pencil"></i>&nbsp;&nbsp;編集</span>
        </div>
        <div class="card-body">
          <!-- 旧版 studioKey.html:10-12 の card-body 先頭 <flash-message> 相当 -->
          <div class="col-md-12"><app-flash-message></app-flash-message></div>
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <table class="table-bordered table-sm">
                  <thead>
                    <tr>
                      <th width="50%">表示ID</th>
                      <th width="50%">店舗名</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ studio.sortBy }}</td>
                      <td>{{ studio.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br /><br />
            @if (userPermission <= 30) {
              <div>
                <strong>入退館キー番号の登録</strong>
                <hr />
                <form novalidate #keyEditForm="ngForm">
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label class="col-form-label">区分コース</label>
                      <select class="form-control" [(ngModel)]="addPlan" name="addPlan">
                        <option [ngValue]="undefined">従業員用</option>
                        @for (sp of filteredPlans; track sp.id) {
                          <option [ngValue]="sp">{{ sp.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="row" style="align-items: flex-end;">
                    <div class="col-md-12">
                      <label class="col-form-label pb-0">入退館キー番号</label>
                    </div>
                    <div class="form-group col-md-3">
                      <label class="col-form-label pt-0">接頭辞</label>
                      <input type="text" class="form-control" [(ngModel)]="addPre" name="addPre" sfMaxLength="10" pattern="[0-9A-Za-z]+" (ngModelChange)="numPadding()">
                    </div>
                    <div class="form-group col-md-4">
                      <label class="col-form-label pt-0">連番</label>
                      <div class="bisected-input-wrap">
                        <div class="bisected-input">
                          <input type="number" class="form-control" min="1" max="9999999999" [(ngModel)]="addStart" name="addStart" required (ngModelChange)="numPadding()">
                        </div>
                        <span>&nbsp;~&nbsp;</span>
                        <div class="bisected-input">
                          <input type="number" class="form-control" min="1" max="9999999999" [(ngModel)]="addEnd" name="addEnd" required (ngModelChange)="numPadding()">
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <label class="col-form-label pt-0">接尾辞</label>
                      <input type="text" class="form-control" [(ngModel)]="addSuf" name="addSuf" sfMaxLength="10" pattern="[0-9A-Za-z]+" (ngModelChange)="numPadding()">
                    </div>
                    <div class="form-group col-md-2">
                      <button type="button" class="btn btn-success" (click)="saveKeyNumber()" [disabled]="keyEditForm.invalid || addRange < 0 || addRange > 5000 || saving">
                        <i class="fa s-icon-plus"></i>&nbsp;登録
                      </button>
                    </div>
                    @if (addPaddingStart) {
                      <div class="form-group col-md-12 text-secondary">
                        <span>登録範囲: {{ addPaddingStart }} ~ {{ addPaddingEnd }}</span>
                      </div>
                    }
                  </div>
                </form>
                <br /><br />
              </div>
              <div>
                <strong>入退館キー番号の削除</strong>
                <hr />
                <form novalidate #keyRemoveForm="ngForm">
                  <div class="row" style="align-items: flex-end;">
                    <div class="col-md-12">
                      <label class="col-form-label pb-0">入退館キー番号</label>
                    </div>
                    <div class="form-group col-md-3">
                      <label class="col-form-label pt-0">接頭辞</label>
                      <input type="text" class="form-control" [(ngModel)]="remPre" name="remPre" sfMaxLength="10" pattern="[0-9A-Za-z]+" (ngModelChange)="removeNumPadding()">
                    </div>
                    <div class="form-group col-md-4">
                      <label class="col-form-label pt-0">連番</label>
                      <div class="bisected-input-wrap">
                        <div class="bisected-input">
                          <input type="number" class="form-control" min="1" max="9999999999" [(ngModel)]="remStart" name="remStart" required (ngModelChange)="removeNumPadding()">
                        </div>
                        <span>&nbsp;~&nbsp;</span>
                        <div class="bisected-input">
                          <input type="number" class="form-control" min="1" max="9999999999" [(ngModel)]="remEnd" name="remEnd" required (ngModelChange)="removeNumPadding()">
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <label class="col-form-label pt-0">接尾辞</label>
                      <input type="text" class="form-control" [(ngModel)]="remSuf" name="remSuf" sfMaxLength="10" pattern="[0-9A-Za-z]+" (ngModelChange)="removeNumPadding()">
                    </div>
                    <div class="form-group col-md-2">
                      <button type="button" class="btn btn-danger" (click)="removeKeyNumber()" [disabled]="keyRemoveForm.invalid || removeRange < 0 || removeRange > 5000 || saving">
                        <i class="fa s-icon-delete"></i>&nbsp;削除
                      </button>
                    </div>
                    @if (remPaddingStart) {
                      <div class="form-group col-md-12 text-secondary">
                        <span>削除範囲: {{ remPaddingStart }} ~ {{ remPaddingEnd }}</span>
                      </div>
                    }
                  </div>
                </form>
                <br /><br />
              </div>
            }
            <strong>入退館キー番号一覧</strong>
            <hr />
            <div class="row">
              <div class="form-group col-md-6">
                <div class="form-group">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword" (ngModelChange)="pageIndex = 0" class="form-control" placeholder="会員名など">
                </div>
              </div>
              <div class="form-group col-md-4 d-flex align-items-end">
                <div class="form-group row">
                  <div class="col-md-12">
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4">
                <div class="form-group">
                  <label class="col-form-label">並べ替え</label>
                  <div class="custom-control custom-radio pl-0 pb-1">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="sort_order_0" class="custom-control-input" [(ngModel)]="sortOrder" value="0" name="sortOrder">
                      <label class="custom-control-label" for="sort_order_0">昇順</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="sort_order_1" class="custom-control-input" [(ngModel)]="sortOrder" value="1" name="sortOrder">
                      <label class="custom-control-label" for="sort_order_1">降順</label>
                    </div>
                  </div>
                  <select class="form-control" [(ngModel)]="sortColumn" name="sortColumn">
                    <option value="keyNumber">入退館キー番号</option>
                    <option value="member.memberCode">会員ID</option>
                    <option value="member.lastNameKana">氏名(かな)</option>
                    <option value="studioPlan.name">区分コース</option>
                    <option value="member.status">状態</option>
                    <option value="member.createdAt">入会日</option>
                  </select>
                </div>
              </div>
              <div class="form-group col-md-4 d-flex align-items-end">
                <div class="form-group row">
                  <div class="col-md-12">
                    <button class="btn btn-success text-white" type="button" (click)="sort()" [disabled]="!keys.length">
                      <i class="fa fa-sort"></i>&nbsp;並び替え
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading) {
              <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
              <table class="table table-bordered table-sm table-hover table-ptb-0">
                <thead>
                  <tr>
                    <th width="15%">
                      入退館キー番号
                      @if (sortIcon === 'keyNumber') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'keyNumber_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                    <th width="10%">
                      会員ID
                      @if (sortIcon === 'member.memberCode') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'member.memberCode_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                    <th width="20%">
                      氏名(かな)
                      @if (sortIcon === 'member.lastNameKana') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'member.lastNameKana_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                    <th width="30%">
                      区分コース
                      @if (sortIcon === 'studioPlan.name') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'studioPlan.name_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                    <th width="10%">
                      状態
                      @if (sortIcon === 'member.status') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'member.status_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                    <th width="15%">
                      入会日
                      @if (sortIcon === 'member.createdAt') { <i class="fa fa-sort-amount-asc text-secondary" title="昇順"></i> }
                      @if (sortIcon === 'member.createdAt_desc') { <i class="fa fa-sort-amount-desc text-secondary" title="降順"></i> }
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of pagedKeys; track item.id) {
                    <tr [class.table-secondary]="isStaleKey(item)" [class.text-secondary]="isStaleKey(item)">
                      <td>{{ item.keyNumber }}</td>
                      <td>
                        @if (item.member) { {{ item.member.memberCode }} }
                        @if (item.user) { &nbsp;-&nbsp; }
                      </td>
                      <td>
                        @if (item.member) { {{ item.member.lastName }}&nbsp;{{ item.member.firstName }}({{ item.member.lastNameKana }}&nbsp;{{ item.member.firstNameKana }}) }
                        @if (item.user) { {{ item.user.name }} }
                      </td>
                      <td>
                        @if (item.member) { {{ item.member.studioPlan?.name }} }
                        @if (!item.member && item.studioPlan) { {{ item.studioPlan.name }} }
                        @if (item.isStaff === 1) { 従業員用 }
                      </td>
                      <td>
                        @if (item.member?.status === 0 || item.user?.status === 0) { 在籍中 }
                        @if (item.member?.status === 1 || item.user?.status === 1) { 停止 }
                        @if (item.member?.status === 2) { 停止(除名) }
                        @if (item.member?.status === 3) { 削除済 }
                      </td>
                      <td>
                        @if (item.member) { {{ item.member.createdAt | date: 'yyyy/MM/dd' }} }
                        @if (item.user) { &nbsp;-&nbsp; }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class StudioKeyComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private keyNumberService = inject(KeyNumberService);
  private authState = inject(AuthStateService);
  private route = inject(ActivatedRoute);
  private flash = inject(FlashService);

  studioId!: number;
  studio: any = {};
  keys: any[] = [];
  loading = true;
  saving = false;

  addPlan: any = undefined;
  addPre = '';
  addSuf = '';
  addStart: number | null = null;
  addEnd: number | null = null;
  addPaddingStart = '';
  addPaddingEnd = '';

  remPre = '';
  remSuf = '';
  remStart: number | null = null;
  remEnd: number | null = null;
  remPaddingStart = '';
  remPaddingEnd = '';

  keyword = '';
  sortOrder = '0';
  sortColumn = 'keyNumber';
  sortIcon = '';
  readonly pageLimit = 300;
  pageIndex = 0;


  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  get filteredPlans(): any[] {
    return (this.studio.studioPlans ?? []).filter((sp: any) => sp.status === 0 && sp.noShowAvailable === 1);
  }

  get filteredKeys(): any[] {
    return this.keys.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedKeys(): any[] {
    const start = this.pageIndex * this.pageLimit;
    return this.filteredKeys.slice(start, start + this.pageLimit);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredKeys.length / this.pageLimit);
  }

  get addRange(): number {
    return this.addStart != null && this.addEnd != null ? this.addEnd - this.addStart : -1;
  }

  get removeRange(): number {
    return this.remStart != null && this.remEnd != null ? this.remEnd - this.remStart : -1;
  }

  goToPage(page: number): void {
    this.pageIndex = Math.max(0, Math.min(page, Math.max(this.totalPages - 1, 0)));
  }

  isStaleKey(item: any): boolean {
    return (item.member != null && item.id !== item.member.keyNumberId) ||
           (item.user != null && item.id !== item.user.keyNumberId);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studioId = +this.route.snapshot.params['studioId'];
    await Promise.all([this.loadStudio(), this.loadKeys()]);
  }

  async loadStudio(): Promise<void> {
    const data: any = await this.studioService.list(this.studioId);
    this.studio = Array.isArray(data) ? (data[0] ?? {}) : (data ?? {});
  }

  async loadKeys(): Promise<void> {
    this.loading = true;
    try {
      this.keys = (await this.studioService.getKeyNumber(this.studioId)) ?? [];
    } finally {
      this.loading = false;
    }
  }

  numPadding(): void {
    if (!this.addStart || !this.addEnd || this.addStart > this.addEnd) {
      this.addPaddingStart = '';
      this.addPaddingEnd = '';
      return;
    }
    const endStr = String(this.addEnd);
    this.addPaddingStart = (this.addPre ?? '') + ('0000000000' + this.addStart).slice(-endStr.length) + (this.addSuf ?? '');
    this.addPaddingEnd = (this.addPre ?? '') + this.addEnd + (this.addSuf ?? '');
  }

  removeNumPadding(): void {
    if (!this.remStart || !this.remEnd || this.remStart > this.remEnd) {
      this.remPaddingStart = '';
      this.remPaddingEnd = '';
      return;
    }
    const endStr = String(this.remEnd);
    this.remPaddingStart = (this.remPre ?? '') + ('0000000000' + this.remStart).slice(-endStr.length) + (this.remSuf ?? '');
    this.remPaddingEnd = (this.remPre ?? '') + this.remEnd + (this.remSuf ?? '');
  }

  async saveKeyNumber(): Promise<void> {
    if (!this.addStart || !this.addEnd || this.addRange < 0 || this.addRange > 5000) return;
    this.saving = true;
    try {
      const pre = this.addPre ?? '';
      const suf = this.addSuf ?? '';
      const isExists = await this.keyNumberService.exists(pre, suf, this.addStart, this.addEnd);
      if (isExists) {
        this.flash.create('danger', '登録されていない入退館キー番号を指定してください');
        window.scrollTo(0, 0);
        return;
      }
      await this.keyNumberService.create({
        studioId: this.studioId,
        studioPlanId: this.addPlan?.id ?? null,
        isStaff: this.addPlan ? 0 : 1,
        prefix: pre,
        suffix: suf,
        start: this.addStart,
        end: this.addEnd,
      });
      this.flash.create('success', '入退館キー番号を新規作成しました');
      window.scrollTo(0, 0);
      this.addPlan = undefined;
      this.addPre = '';
      this.addSuf = '';
      this.addStart = null;
      this.addEnd = null;
      this.addPaddingStart = '';
      this.addPaddingEnd = '';
      await this.loadKeys();
    } catch {
      this.flash.create('danger', '入退館キー番号を確認・登録できませんでした。表示を再取得してから、もう一度お試しください。');
    } finally {
      this.saving = false;
    }
  }

  async removeKeyNumber(): Promise<void> {
    if (!this.remStart || !this.remEnd || this.removeRange < 0 || this.removeRange > 5000) return;
    this.saving = true;
    try {
      const pre = this.remPre ?? '';
      const suf = this.remSuf ?? '';
      const isInUse = await this.keyNumberService.inUse(pre, suf, this.remStart, this.remEnd);
      if (isInUse) {
        this.flash.create('danger', '使用されていない入退館キー番号を指定してください');
        window.scrollTo(0, 0);
        return;
      }
      await this.keyNumberService.remove({
        studioId: this.studioId,
        prefix: pre,
        suffix: suf,
        start: this.remStart,
        end: this.remEnd,
      });
      this.flash.create('success', '入退館キー番号を削除しました');
      window.scrollTo(0, 0);
      this.remPre = '';
      this.remSuf = '';
      this.remStart = null;
      this.remEnd = null;
      this.remPaddingStart = '';
      this.remPaddingEnd = '';
      await this.loadKeys();
    } catch {
      this.flash.create('danger', '入退館キー番号を確認・削除できませんでした。表示を再取得してから、もう一度お試しください。');
    } finally {
      this.saving = false;
    }
  }

  sort(): void {
    if (!this.keys.length) return;
    this.pageIndex = 0;
    this.sortIcon = this.sortColumn;
    const cols = this.sortColumn.split('.');
    this.keys = [...this.keys].sort((a, b) => {
      let valA: any, valB: any;
      if (/lastNameKana/.test(this.sortColumn)) {
        valA = a.member ? (a.member.lastNameKana + a.member.firstNameKana) : '';
        valB = b.member ? (b.member.lastNameKana + b.member.firstNameKana) : '';
      } else if (cols.length === 2) {
        valA = a[cols[0]] ? a[cols[0]][cols[1]] : null;
        valB = b[cols[0]] ? b[cols[0]][cols[1]] : null;
      } else {
        valA = a[cols[0]];
        valB = b[cols[0]];
      }
      if (valA > valB) return 1;
      if (valA < valB) return -1;
      return 0;
    });
    if (this.sortOrder === '1') {
      this.keys.reverse();
      this.sortIcon += '_desc';
    }
  }

  clearFilter(): void {
    this.keyword = '';
    this.pageIndex = 0;
  }
}
